import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { usePrevious } from 'react-use';
import useUserData from '.';
const useIsLoggedInCallback = callback => {
  const $ = _c(5);
  const {
    isLoggedIn
  } = useUserData();
  const prevIsLoggedIn = usePrevious(isLoggedIn);
  let t0;
  let t1;
  if ($[0] !== callback || $[1] !== isLoggedIn || $[2] !== prevIsLoggedIn) {
    t0 = () => {
      if (isLoggedIn !== prevIsLoggedIn) {
        callback?.();
      }
    };
    t1 = [isLoggedIn, prevIsLoggedIn, callback];
    $[0] = callback;
    $[1] = isLoggedIn;
    $[2] = prevIsLoggedIn;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  return isLoggedIn;
};
export default useIsLoggedInCallback;